// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sl-mobile-store{width:100%;height:100%}", "",{"version":3,"sources":["webpack://./src/features/shared/public/SlMobileStores/SlMobileStores.scss"],"names":[],"mappings":"AAAA,iBACI,UAAA,CACA,WAAA","sourcesContent":[".sl-mobile-store {\n    width: 100%;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
